/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import MidContainer from '@Layout/MidContainer';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import {
  getLocale
} from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import { getLandingPaths } from 'services/newsService';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 */
const Search = ({ region, language, pageData, newsData }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  useEffect(() => {
    (() => {
      let gcseScript = document.createElement('script');
      gcseScript.type = 'text/javascript';
      gcseScript.async = true;
      gcseScript.src = 'https://cse.google.com/cse.js?cx=013988788890882223359:9_evkvtkg0y';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(gcseScript, s);
    })();
  }, []);

  // consoleLog('page', pageData);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" className="page-wrap container-article" p="0">
        <MidContainer>
          <Box m="30px 0" mx="15px" py="15px">
            <div
              className="gcse-searchbox"
              data-resultsUrl="https://isha.sadhguru.org"
              data-newWindow="false"
              data-queryParameterName="search"
            >
              <div
                className="gcse-searchbox"
                data-enableHistory="true"
                data-autoCompleteMaxCompletions="5"
              />
              <div className="gcse-searchresults"></div>
            </div>
          </Box>
        </MidContainer>
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const searchLandingPaths = config.USE_LOCAL_URL
    ? [
      `/in/en/search`,
      `/au/en/search`,
      `/ca/en/search`,
      `/my/en/search`,
      `/sg/en/search`,
      `/uk/en/search`,
      `/us/en/search`,
      `/global/en/search`,
    ]
    : await getLandingPaths('lvl0', '/search', '/mahashivratri/search');
  return {
    paths: searchLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  //   const pageData = await fetchDetails(region, language);
  let pageData = {
    _seoMetaTags: [
      {
        tag: 'title',
        content: 'Isha Search | Enhanced by Google',
        attributes: null,
      }
    ]
  };

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null
    }
  };
};

export default Search;
